module.exports = __webpack_public_path__ + "img/Deathknight-human-f-70.aa2fc202.gif";